export const MemberStatusConstants = {
  NONE: 'ACFFCA30-C6CC-4A86-BDAA-16FA3C068B51'.toLowerCase(),
  DISCONTINUED: 'ADC285CE-2F8F-42CB-9AB5-4170E6D1AA97'.toLowerCase(),
  INCOMPLETE: '6745EC29-5E50-4964-8E67-6D2C6E2A0DB3'.toLowerCase(),
  NEW_REGISTRATION: '25465814-3BD5-4FBA-B521-DF323EA56FE9'.toLowerCase(),
  ACTIVE: '4A77AAF9-116F-43CE-B6F9-DF6CF4CFA641'.toLowerCase(),
  BLOCKED: 'D44B7C94-B744-4070-973A-EBBD457086C1'.toLowerCase(),
  ARREARS: 'E8A7B5C3-9D1F-4E2A-8C6B-3F4A5D7E9B1C'.toLowerCase(),
};
